import React from "react";

import { ScrollNavMenuBlock as BaseMenu } from "@thelabnyc/thelabui/src/components/ScrollNavMenuBlock";

import { TextLink } from "../Clickables";
import { Svg } from "../Svg";

import styles from "./index.module.scss";

export { ScrollNavMenuItemBlock } from "@thelabnyc/thelabui/src/components/ScrollNavMenuBlock";

export function ScrollNavMenu({
    value,
}: Pick<React.ComponentProps<typeof BaseMenu>, "value">) {
    return (
        <div className={styles.root}>
            <BaseMenu value={value} classNames={styles} />
            {value.right_cta && (
                <TextLink
                    className={styles.right}
                    simpleLink={value.right_cta}
                    icon={<Svg name="arrow" />}
                />
            )}
        </div>
    );
}
